import { render, staticRenderFns } from "./siteLoader.vue?vue&type=template&id=b931e84a&scoped=true&"
var script = {}
import style0 from "./siteLoader.vue?vue&type=style&index=0&id=b931e84a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b931e84a",
  null
  
)

export default component.exports